import axios from "axios";
import { buildApiUrl } from "../config";
import authService from "./auth";

const alertaService = {
  getMinhasAlertas: async () => {
    const response = await axios.get(buildApiUrl("Alerta/minhas"), {
      headers: authService.getAuthHeader(),
    });
    return response.data;
  },

  marcarVistas: async () => {
    const response = await axios.put(
      buildApiUrl("Alerta/marcar-vistas"),
      {},
      { headers: authService.getAuthHeader() }
    );
    return response.data;
  },
};

export default alertaService;
